const styles = {
  cellStyle: {
    fontSize: "14px",
    fontWeight: 400,
  },
  containerCell: {
    cursor: "pointer",
  },
};

export default styles;
